<template>
    <div class="sau-bx p-6">
        <template v-if="activeStorageSets">
            <div v-for="(set, index) in config" :key="index">
                <template v-if="index < activeStorageSets">
                    <div class="row m-4 mb-12">
                        <div class="col-6">
                            <h5>{{ storageSetLabel(index) }}</h5>
                        </div>
                        <div class="col-6" v-if="index">
                            <p class="text-right text-danger"><span @click.prevent="removeStorageSet(index)">Remove Disk Set</span></p>
                        </div>
                        <div class="col-12">
                            <div class="row m-0 p-6 sau-bx">

                                <div class="col-md-6 mb-0 text-center">
                                    <div class="sau-bx p-6 border-bottom-0">
                                        <input type="radio" value="SSD" v-model="selectedStorageType[index]" @change="updateStorageSet('SSD', index)">
                                        <h5 class="mb-0">SSD</h5>
                                    </div>
                                    <div class="sau-bx">
                                        <select class="form-control sau-bx sau-select" @change="updateStorageSet('SSD', index)" ref="ssdStorage" v-model="storageRef[index].SSD">
                                            <option v-for="(option, key) in storageOptions('SSD', index)" :key="key" :value="option.id" >{{ option.description }} - {{ option.price[userCurrency] | currency }}</option>
                                        </select>
                                    </div>
                                </div>

                                <div class="col-md-6 mb-0 text-center">
                                    <div class="sau-bx p-6 border-bottom-0">
                                        <input type="radio" value="SATA" v-model="selectedStorageType[index]" @change="updateStorageSet('SATA', index)">
                                        <h5 class="mb-0">SATA</h5>
                                    </div>
                                    <div class="sau-bx">
                                        <select class="form-control sau-bx sau-select" @change="updateStorageSet('SATA', index)" ref="sataStorage" v-model="storageRef[index].SATA">
                                            <option v-for="(option, key) in storageOptions('SATA', index)" :key="key" :value="option.id">{{ option.description }} - {{ option.price[userCurrency] | currency }}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>

            <div class="row m-4" v-if="activeStorageSets < 4">
                <div class="col-12" @click="addStorageSet()">
                    <div class="row m-0 align-items-center sau-bx">
                        <div class="col-auto sau-bx sau-bx-right text-center icon-large">
                            <i class="fal fa-plus"></i>
                        </div>
                        <div class="col-auto">
                            Add a new disk set
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        type: String,
        data: Object,
        dedi: Object,
    },

    data() {
        return {
            storage: [],
            config: [],
            selectedStorageType: [],
            storageRef: [],
            disksets: [],
        }
    },

    mounted() {
        this.setUp();
    },

    methods: {
        storageSetLabel(index) {
            switch(index) {
                case 0:
                    return 'Primary Disk';
                case 1:
                    return 'Secondary Disk';
                default:
                    return 'Additional Disk';
            }
        },

        setUp() {
            this.config = this.data.config.products.dedicatedserver.storage;
            this.storage = this.dedi.storage;

            // Build a fake object for handling multiple selects bound to the same property
            for (let i = 0; i < 4; i++) {
                let disk = this.storage[i];
                let ssd = this.config[i].options.SSD[0];
                let sata = this.config[i].options.SATA[0];

                if (this.storage.length > i) {

                    // no disk.type - look it up from the ids
                    let selected = this.config[i].options.SATA.find(option => option.id == disk.id);
                    // If selected isnt null then the disk type is SATA otherwise its SSD
                    disk.type = selected ? 'SATA' : 'SSD';

                    this.selectedStorageType.push(disk.type);

                    if (disk.type === 'SATA') {
                        this.storageRef.push({'SATA': disk.id, 'SSD': ssd.id});
                    } else if (disk.type === 'SSD') {
                        this.storageRef.push({'SATA': sata.id, 'SSD': disk.id});
                    }
                } else {
                    this.selectedStorageType.push('SSD');
                    this.storageRef.push({'SATA': sata.id, 'SSD' : ssd.id});
                }
            }

            if (!this.storage.length) this.addStorageSet();

            this.updateStorage(); // Ensure default values are set.
        },

        removeStorageSet(index) {

            // Remove the selected storage
            this.storage.splice(index, 1);
            this.reindexStorage(index);
            this.updateStorage();

        },

        reindexStorage(removed) {

            this.storage.forEach((disk, index) => {
                // Only reindex entries after the storage that was removed
                if(index >= removed) {

                    let updated = this.getCorrectStorageIndex(disk.id, index, disk.type);

                    this.selectedStorageType[index] = updated.type;
                    this.storageRef[index][disk.type] = updated.id;
                    this.storage[index].set = `storage_set${index + 1}`;
                    this.storage[index].id = updated.id,
                    this.storage[index].description = updated.description;
                    this.storage[index].type = updated.type;
                }
            });
        },

        getCorrectStorageIndex(id, index, type) {

            // Return the original storage
            let oldStorage = this.config[index + 1].options[type].find((disk) => {
                            return disk.id == id;
                        });

            if(oldStorage) {

                let newStorage = this.config[index].options[type].find((storage) => {
                                return storage.description == oldStorage.description;
                            });

                return newStorage ? newStorage : this.config[index].options[type][0];

            }

            return this.config[index].options[type][0];
        },

        addStorageSet() {

            let nextSet = this.storage.length;

            this.storage.push({
                id: this.config[nextSet].options.SSD[0].id,
                set: 'storage_set' + (nextSet + 1),
                type: 'SSD',
            });

            // Loop through the storage set for this dedi and filter out the required properties for the endpoint, convert to json and send
            // this.updateStorage().then(() => {
            //     this.updateStorageSet('SSD', nextSet)
            // });

            this.updateStorage();
        },

        updateStorage() {
            return new Promise((resolve, reject) => {
                window.bus.$once('order.items.updated', () => {
                    resolve();
                    window.bus.$emit('order.refresh');
                });
                this.updateDedi({
                    storage: JSON.stringify(
                        this.storage.map(set => {
                            return window._.pick(set, ['id', 'set']);
                        })
                    ),
                });
            });
        },

        updateDedi(data) {
            window.bus.$emit('order.items.update', this.type, this.dedi.slug, data);
        },

        updateStorageSet(type, index) {
            let key = type === 'SSD' ? 'ssdStorage' : 'sataStorage';
            this.storage[index].id = this.$refs[key][index].value;
            this.storage[index].type = type;
            this.updateStorage();
        },

        storageOptions(type, index) {
            // return this.config[index].options[type];
            return this.filteredConfig[index].options[type];
        },

    },

    computed: {
        activeStorageSets() {
            return this.storage.length;
        },

        filteredConfig() {
            return this.config.map((storage) => {
                if(storage.hasOwnProperty('options') && storage.options.hasOwnProperty('SATA')) {
                    storage.options.SATA = storage.options.SATA.filter((drive) => {
                        return parseFloat(drive.price.AUD) < 10000;
                    });
                }
                if(storage.hasOwnProperty('options') && storage.options.hasOwnProperty('SSD')) {
                    storage.options.SSD = storage.options.SSD.filter((drive) => {
                        return parseFloat(drive.price.AUD) < 10000;
                    });
                }
                return storage;
            })
        }
    }
}
</script>
<style lang="scss" scoped>
    .sau-select {
        border: none;
        text-align-last: center; // Chrome
        text-align: center; // Firefox
        padding-top:0px !important;
        &:focus, &:hover {
            outline: none;
            box-shadow: none;
            border: none;
        }
    }
    .sau-select {
        padding-top:0px !important;
    }
    .icon-large {
        font-size: 3rem;
    }
    .sau-bx-right {
        border-top: 0;
        border-left: 0;
        border-bottom: 0;
    }
</style>
